import { Injector } from '@angular/core';
import { B2bMobileCheckoutErrorTrackerService } from './b2b-mobile-checkout-error-tracker.service';

export async function lazyB2bMobileCheckoutErrorTracker(
  injector: Injector
): Promise<B2bMobileCheckoutErrorTrackerService> {
  const { B2bMobileCheckoutErrorTrackerService } = await import('./b2b-mobile-checkout-error-tracker.service');
  return injector.get(B2bMobileCheckoutErrorTrackerService);
}
